/**
 * Europe region codes
 */
export const EU_COUNTRIES = [
  'AD',
  'AL',
  'AT',
  'AX',
  'BA',
  'BE',
  'BG',
  'BY',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FO',
  'FR',
  'GI',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MD',
  'ME',
  'MK',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'RS',
  'RU',
  'SE',
  'SI',
  'SJ',
  'SK',
  'SM',
  'TR',
  'UA',
  'VA',
  'XK'
];

/**
 * UK region codes
 */
export const UK_COUNTRIES = ['GB', 'GG', 'IM', 'JE'];

/**
 * APAC region codes
 */
export const APAC_COUNTRIES = ['HK', 'SG', 'KR', 'TW'];

/**
 * United States country code
 */
export const US_COUNTRY = 'US';

/**
 * Japan country code
 */
export const JP_COUNTRY = 'JP';

/**
 * Australia country code
 */
export const AU_COUNTRY = 'AU';

/**
 * New Zealand country code
 */
export const NZ_COUNTRY = 'NZ';

export const excludeRoutes = ['/_next', '/api', '/.'];
